import { Alert, Typography, alpha, useTheme } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

interface ConflictAlertProps {
  visible: boolean;
  title?: string;
  description?: string;
}

/**
 * Orange warning banner shown when generating a Magic Link report fails.
 * Hidden when visible=false.
 */
export default function ConflictAlert({
  visible,
  title = 'Magic Link Report Generation Failed',
  description = 'Something went wrong while generating the Magic Link report. Please try again.',
}: ConflictAlertProps) {
  const theme = useTheme();

  if (!visible) return null;

  return (
    <Alert
      id="conflict-alert"
      severity="warning"
      icon={<ErrorOutlineIcon fontSize="small" />}
      sx={{
        mb: 2,
        borderRadius: '10px',
        border: `1px solid ${alpha(theme.palette.warning.main, 0.3)}`,
        backgroundColor: alpha('#FFF8E1', 0.7),
        '& .MuiAlert-icon': { color: theme.palette.warning.main, alignItems: 'flex-start', pt: 0.25 },
        '& .MuiAlert-message': { py: 0 },
      }}
    >
      <Typography variant="body2" fontWeight={700} color="warning.dark">
        {title}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {description}
      </Typography>
    </Alert>
  );
}
